import { initializePaddle, type Paddle } from "@paddle/paddle-js";

let paddleInstance: Paddle | undefined;
let initPromise: Promise<Paddle | undefined> | null = null;
const paddleEventTarget = new EventTarget();
let registeredInitLogger = false;

/**
 * 预初始化（在 app 启动或系统闲置时调用）
 */
export async function initPaddle(): Promise<Paddle | undefined> {
  if (paddleInstance) return paddleInstance;
  if (initPromise) return initPromise;

  initPromise = (async () => {
    try {
      const token = import.meta.env.VITE_PADDLE_CLIENT_TOKEN;
      const env = import.meta.env.VITE_PADDLE_ENV === "sandbox" ? "sandbox" : "production";

      paddleInstance = await initializePaddle({
        token,
        environment: env,
        eventCallback: data => {
          // 将 paddle-js 的回调包装成 DOM Event 派发
          paddleEventTarget.dispatchEvent(new CustomEvent("paddle-event", { detail: data }));
        },
      });

      if (!registeredInitLogger) {
        registeredInitLogger = true;
      }

      return paddleInstance;
    } catch (err) {
      console.log(err, "【init paddle】 init error");
      paddleInstance = undefined;
      throw err;
    }
  })();

  return initPromise;
}

/**
 * 获取 Paddle 实例（如果未初始化会等待 initPromise）
 */
export async function getPaddleInstance(): Promise<Paddle | undefined> {
  if (paddleInstance) return paddleInstance;
  return initPaddle();
}

/**
 * 暴露一个 EventTarget，用于 hook 注册 paddle 事件（避免把事件散布在 window 上）
 */
export function getPaddleEventTarget(): EventTarget {
  return paddleEventTarget;
}

/**
 * 关闭 Paddle Checkout 弹窗
 */
export function closePaddleCheckout(): void {
  if (paddleInstance) {
    paddleInstance.Checkout.close();
  }
}
